define([
	'internal_util/Util',
	
	'amdi18n-loader?!state/nls/BindingState_strings',
	
	'view/UIView',
	'lib/jquery'
], function (
	Util,
	
	Strings,
	
	UIView,
	jQuery
) {
	'use strict';

	/**
	 * TextView class
	 */
	return function TransferConfirmationView() {
		var _view = jQuery(
				'<div class="skIdS_text-container">' +
					'<p>' +Strings.confirm_transfer+ '</p>' +
					'<br/>' +
					'<button id="skIdS_confirm-button" type="button" class="btn btn-default skIdS_identity-button">' +Strings.confirm+ '</button>' +
				'</div>'
				);

		UIView.call(this);

		_view.find('#skIdS_confirm-button').hide();

		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function () {
			// nothing to do
		};

		this.setCallback = function (callback) {
			if (callback) {
				_view.find('#skIdS_confirm-button').show();
				_view.find('#skIdS_confirm-button').on('click', callback);
			}
		};

	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/bindings/TransferConfirmationView.js
// module id = 342
// module chunks = 1